// src/data/hero.ts — ヒーローの事実リスト（仕様 付録 A「Hero」）
export interface HeroFact {
  label: string;
  value: string;
}

export const HERO_FACTS: readonly HeroFact[] = [
  { label: 'AWS 認定', value: '12 冠' },
  { label: '経歴', value: '元 AWS Japan\nソリューションアーキテクト' },
  { label: '設立', value: '2025年11月\n石川県金沢市' },
];
